import React, { useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { LOCALES, useI18n } from '../i18n';

export default function LanguageSwitcher() {
  const { locale, setLocale, t } = useI18n();
  const [anchorEl, setAnchorEl] = useState(null);

  const current = LOCALES.find((l) => l.id === locale);

  const handleSelect = (id) => {
    setLocale(id);
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        color="inherit"
        size="small"
        startIcon={<LanguageIcon />}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        aria-label={t('header.languageMenu')}
        aria-haspopup="true"
        sx={{ textTransform: 'none', color: 'text.primary' }}
      >
        {current.short}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {LOCALES.map((l) => (
          <MenuItem
            key={l.id}
            selected={l.id === locale}
            onClick={() => handleSelect(l.id)}
          >
            {l.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
